import { Field, Form } from 'formik';
import React, { useContext, useState, useEffect } from 'react';

import { FloatingInputVersionTwo, FormLayout } from 'src/components';
import { MiniAppFocusWrapper } from 'src/components/miniapp-focus-wrapper/miniapp-focus-wrapper';
import { phoneNumberMaskSpaced, stripWhitespace } from 'src/helpers/formatting';
import { SalesforceContext } from 'src/context/salesforce-context';
import { isValidEmail, isValidMobileNumber, validateEmailTradeRoot } from 'src/helpers/validation';
import FormikEnhanced from 'src/components/formik-enhanced/formik-enhanced';
import TealiumEvents from 'src/helpers/tealium-events';
import './more-details.scss';

export default function MoreDetails(props) {
  const { merchant, setMerchant, customerType } = useContext(SalesforceContext);
  const [errorState, setErrorState] = useState(false);

  useEffect(() => {
    if (merchant?.account?.business_type) {
      TealiumEvents.moreDetailsPageLoadFormStartCombined(
        merchant.account.business_type,
        customerType,
      );
    }
  }, [merchant?.account?.business_type]);

  useEffect(() => {
    props.toggleNext(isCompletedForm(getMoreDetails()));
  }, [merchant, errorState]);

  const getMoreDetails = () => ({
    maritalStatus: merchant?.contact?.marital_status || '',
    email: merchant?.contact?.email || '',
    mobileNumber: merchant?.contact?.phone || '',
  });
  const setMoreDetails = (newMerchantDetails) => {
    setMerchant({
      ...merchant,
      contact: {
        ...merchant.contact,
        phone: newMerchantDetails.mobileNumber,
        marital_status: newMerchantDetails.maritalStatus,
        email: newMerchantDetails.email,
      },
    });
  };

  const maritalStatuses = ['Married', 'Single', 'Divorced', 'Widowed'];

  return (
    <div>
      <div className="MoreDetails" data-testid="MoreDetails">
        <FormikEnhanced
          initialValues={getMoreDetails()}
          validate={validateForm}
          validateOnChange={true}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          <div className="more-details-container">
            <div>
              <h1 className="text-center page-title heading-four has-padding-bottom-3 has-mobile-padding-bottom-5">
                We just need more details
              </h1>
              <p className="text-center page-title content-normal has-padding-bottom-2 has-mobile-padding-bottom-3">
                We need your details as an authorised business representative
              </p>
              <Form>
                <FormLayout>
                  <Field
                    name="maritalStatus"
                    type="text"
                    placeholder="Marital status"
                    items={maritalStatuses}
                    getItemDisplayValue={(item) => item}
                    component={MiniAppFocusWrapper}
                    innerComponent={FloatingInputVersionTwo}
                    fieldType="select"
                    className="dark"
                  />
                  <Field
                    name="email"
                    type="text"
                    placeholder="Email address"
                    component={MiniAppFocusWrapper}
                    innerComponent={FloatingInputVersionTwo}
                    fieldType="standard"
                    className="dark"
                  />
                  <Field
                    id="mobileNumber"
                    name="mobileNumber"
                    mask={phoneNumberMaskSpaced}
                    type="tel"
                    placeholder="Primary contact number"
                    component={MiniAppFocusWrapper}
                    innerComponent={FloatingInputVersionTwo}
                    fieldType="masked"
                    className="dark bottom-field"
                  />
                </FormLayout>
              </Form>
            </div>
          </div>
        </FormikEnhanced>
      </div>
    </div>
  );

  function isCompletedForm(values) {
    const invalidMaritalStatus = !values?.maritalStatus;
    const invalidEmail = !values?.email;
    const invalidMobileNumber = !values?.mobileNumber;

    return !(errorState || invalidEmail || invalidMaritalStatus || invalidMobileNumber);
  }

  function validateForm(values) {
    //Strip whitespace from mobile numbers
    values.mobileNumber = stripWhitespace(values.mobileNumber);
    values.email = stripWhitespace(values.email);

    const errors = {};

    const emailTradeRootValidationError = validateEmailTradeRoot(values.email);

    if (emailTradeRootValidationError) {
      errors.email = values.email ? emailTradeRootValidationError : null;
    } else {
      const invalidEmail = !isValidEmail(values.email);
      errors.email = invalidEmail ? 'The email address entered is invalid' : null;
    }

    const invalidMobileNumber = !isValidMobileNumber(values.mobileNumber);
    errors.mobileNumber = invalidMobileNumber ? 'The mobile number entered is invalid' : null;

    const anyErrors = !Object.values(errors).every((value) => value === null);
    setErrorState(anyErrors);

    if (!anyErrors) {
      setMoreDetails(values);
    }
    return errors;
  }
}
